// extracted by mini-css-extract-plugin
export default {"qonto-logo":"lxjYpgFfkz41g5ew0vRYqA=="};